/**
 * API xatosi — `AllExceptionsFilter` formatidagi javob (docs/07-API.md §1).
 *
 * `code` — barqaror identifikator: interfeys shunga qarab xabar tanlaydi.
 * `message` ga qarab shart yozish taqiqlanadi — matn o'zgarganda kod
 * jimgina buzilardi.
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** Maydonlar bo'yicha validatsiya xatolari — formada ko'rsatish uchun. */
  get fieldErrors(): Record<string, string> {
    if (this.code !== 'VALIDATION_FAILED' || !Array.isArray(this.details)) return {};

    const out: Record<string, string> = {};
    for (const issue of this.details as Array<{ path?: string; message?: string }>) {
      if (issue.path && issue.message && !out[issue.path]) out[issue.path] = issue.message;
    }
    return out;
  }
}

/** Tarmoq uzilishi — server javob bermadi. */
export class NetworkError extends Error {
  constructor(cause: unknown) {
    super('Serverga ulanib bo‘lmadi. Internet aloqasini tekshiring');
    this.name = 'NetworkError';
    this.cause = cause;
  }
}

export function isApiError(error: unknown, code?: string): error is ApiError {
  return error instanceof ApiError && (code === undefined || error.code === code);
}

/**
 * Toast uchun xabar.
 *
 * `unknown` dan matn ajratish har bir sahifada takrorlanardi va
 * ba'zilarida `String(error)` yozilib, foydalanuvchi `[object Object]`
 * ko'rardi.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  return 'Kutilmagan xato yuz berdi';
}
